<template>
	<header class="top-header">
		<slot></slot>
		<a :href="'/users/' + currentUser.id + '/edit'" class="current-user ml-auto">Hello,
			<strong>{{ currentUser.first_name }}</strong>!</a>
		<a href="/logout" class="btn btn-sm btn-primary logout"><i class="fas fa-sign-out-alt"></i> Log Out</a>
	</header>
</template>

<script>
export default {
	name: 'TopNav',
	data() {
		return {
			currentUser: this.$currentUser
		}
	}
}
</script>

<style scoped>

</style>
